import React from 'react'
import { Area, AreaChart, CartesianGrid, ResponsiveContainer } from 'recharts'
import { ChartTooltip, XAxis, YAxis } from '../../components'
import { useMediaQuery } from '../../hooks'
import { formatGraphData, getAxisDomain } from '../../helpers'
import { GraphComponentProps } from '../../types'

const CRChart: React.FC<GraphComponentProps> = ({ data, graphHeight }) => {
  const displayType = useMediaQuery()

  const getMonthFormat = () => {
    switch (displayType) {
      case 'tablet':
        return 'three'
      default:
        return 'one'
    }
  }

  const formattedData = formatGraphData('percent', undefined, data, value =>
    Number(value).toFixed(4)
  )
  const domain = getAxisDomain(formattedData, 'percent')

  return (
    <ResponsiveContainer width={'99%'} height={graphHeight}>
      <AreaChart data={formattedData} margin={{ left: 0 }}>
        <defs>
          <linearGradient id="color-cr" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#3AF8B9" stopOpacity={0.2} />
            <stop offset="1" stopColor="#3AF8B9" stopOpacity={0} />
          </linearGradient>
        </defs>
        {XAxis({ monthFormat: getMonthFormat(), chartType: 'line' })}
        {YAxis({ dataKey: 'percent', unit: '%', domain })}
        <CartesianGrid stroke="#CED8FD" strokeDasharray="5 5" />
        {ChartTooltip({ cursor: { stroke: '#292E3D', strokeDasharray: '5 5' } })}
        <Area
          type="monotone"
          strokeWidth={2}
          fillOpacity={1}
          activeDot={{ r: 7.5, strokeWidth: 2 }}
          dataKey="percent"
          stroke="#1CC089"
          fill="url(#color-cr)"
          unit="%"
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}

export default CRChart
